'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export')
  , $pad    = require('./_string-pad');

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es7.string.pad-end.js
 ** module id = 939
 ** module chunks = 0
 **/